import { FC } from "react";
import { components } from "../openapi/generated-types";
import { TeamName } from "./TeamName";
import { TextSkeleton } from "./TextSkeleton";
import { useCompetition } from "../hooks/useCompetition.ts";
import { useGameList } from "../hooks/useGameList.ts";

interface ResolvedTeamReferenceProps {
  teamReference: components["schemas"]["TeamReference"];
  competitionId: string;
}

export const ResolvedTeamReference: FC<ResolvedTeamReferenceProps> = (
  props,
) => {
  const { teamReference, competitionId } = props;

  if ("winnerTeam" in teamReference && teamReference.winnerTeam) {
    return (
      <>
        Sieger{" "}
        <GameName
          competitionId={competitionId}
          gameId={teamReference.winnerTeam}
        />
      </>
    );
  }

  if ("loserTeam" in teamReference && teamReference.loserTeam) {
    return (
      <>
        Verlierer{" "}
        <GameName
          competitionId={competitionId}
          gameId={teamReference.loserTeam}
        />
      </>
    );
  }

  if ("teamId" in teamReference && teamReference.teamId) {
    return <TeamName teamId={teamReference.teamId} />;
  }

  if ("groupId" in teamReference && teamReference.groupId) {
    return (
      <TeamNameByGroupId
        groupId={teamReference.groupId}
        position={teamReference.position}
        competitionId={competitionId}
      />
    );
  }

  return <>Team kann nicht ermittelt werden</>;
};

const GameName: FC<{ gameId: string; competitionId: string }> = (props) => {
  // using gameList here to avoid too many individual game requests
  const { gameId, competitionId } = props;
  const games = useGameList(competitionId);

  if (!games.isSuccess) {
    return <TextSkeleton>Spiel 00</TextSkeleton>;
  }

  const game = games.data.games.find((g) => g.id == gameId);

  if (!game) {
    return <>Unbekanntes Spiel</>;
  }

  return <>{game.name}</>;
};

const TeamNameByGroupId: FC<{
  groupId: string;
  position: number;
  competitionId: string;
}> = (props) => {
  const { position, groupId, competitionId } = props;

  const competition = useCompetition(competitionId);

  if (!competition.isSuccess) {
    return (
      <>
        <TextSkeleton>Gruppe</TextSkeleton>, Platz{" "}
        <TextSkeleton>00</TextSkeleton>
      </>
    );
  }

  const group = competition.data.groups.find((g) => g.id == groupId);
  if (!group) {
    throw new Error(
      `group ${groupId} not found in competition ${competition.data.name} (${competition.data.id})`,
    );
  }
  return (
    <>
      {group.name}, Platz {position}
    </>
  );
};
